'use client';

import { useRouter } from 'next/navigation';
import { useTransition } from 'react';

import { Form, useFormStore } from '@ariakit/react';
import cx from 'classnames';

import { type ActionResult } from '~/ui/actions/types';
import { FormInput } from '~/ui/components/form/input';
import typographyStyles from '~/ui/styles/typography.module.scss';

import styles from './password.module.scss';

export interface PasswordProps {
  header: string;
  authenticateAction: (password: string) => Promise<ActionResult>;
}

export function Password({ header, authenticateAction }: PasswordProps) {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  const form = useFormStore({
    defaultValues: {
      password: '',
    },
  });

  form.useSubmit(state => {
    startTransition(async () => {
      const result = await authenticateAction(state.values.password);
      if (result.success) {
        router.refresh();
      } else {
        form.setError(form.names.password, 'Incorrect password. Please try again.');
      }
    });
  });

  return (
    <Form className={styles.root} store={form} resetOnSubmit={false} validateOnBlur={false}>
      <h2 className={cx(typographyStyles.bodyLarge)}>{header}</h2>

      <FormInput
        className={styles.input}
        fieldName={form.names.password.toString()}
        inputLabel="Password"
        type="password"
        isPending={isPending}
      />
    </Form>
  );
}
